import { Utils } from './utils';

// ハンバーガータイムラインを保持する変数
let hamburgerTweenTimeline = null;

// -----------------------------------------------
// スクロールアニメーション定義
// -----------------------------------------------
// フェードイン
const fadeIn = {
  set: { opacity: 0 },
  to: { opacity: 1, duration: 1.4, delay: 0, ease: 'power2.easeIn' },
};
// ふわっと上がる
const fadeInUp = {
  // set: { x: '-80', opacity: 0 },
  // to: { x: '0', opacity: 1, duration: 1.0, delay: 0, ease: 'power1.easeInOut' },
  set: { y: '50', opacity: 0 },
  to: { y: '0', opacity: 1, duration: 1.0, delay: 0, ease: 'power1.easeInOut' },
};
// アニメーション定義
const animationConfig = {
  fadeIn,
  fadeInUp,
};

// -----------------------------------------------
// スクロールアニメーション初期化
// -----------------------------------------------
function initScrollAnimation(selector, options = { once: true }) {
  const targets = document.querySelectorAll(selector);

  targets.forEach((el) => {
    const anime = JSON.parse(JSON.stringify(animationConfig[el.dataset.anime]));

    // data-animate-pc-only属性がある要素はスマホ表示時はスキップ
    if (Utils.isMobile() && el.hasAttribute('data-animate-pc-only')) {
      return;
    }

    // -------------------------
    // set（初期設定）
    // -------------------------
    // setが配列でない場合は、配列に変換する
    if (!Array.isArray(anime.set)) {
      anime.set = new Array(anime.set);
    }
    anime.set.forEach((set) => {
      let target = el;
      if (set.target) {
        target = set.target;
        delete set.target;
      }
      gsap.set(target, set);
    });

    // -------------------------
    // to（アニメーション）
    // -------------------------
    // toが配列でない場合は、配列に変換する
    if (!Array.isArray(anime.to)) {
      anime.to = new Array(anime.to);
    }

    // scrollTrigger設定
    let st = { scrollTrigger: { trigger: el, start: 'top 90%', markers: false } };
    if (el.dataset.start) {
      st.scrollTrigger.start = el.dataset.start;
    }

    // let st = { scrollTrigger: { trigger: el, markers: true, start: 'top+=50 bottom' } };
    if (!options.once) {
      st.scrollTrigger.toggleActions = 'play reset play reset';
    }

    const tl = gsap.timeline(st);
    anime.to.forEach((to, index) => {
      // 配列の先頭要素だけ、data属性から渡された時間を設定する
      if (index === 0) {
        // data属性 > 定数 の優先度でセットする。全てなしならば0とする
        to.duration = el.dataset.duration || to.duration || 0;
        to.delay = el.dataset.delay || to.delay || 0;
      }

      let target = el;
      if (to.target) {
        target = to.target;
        delete to.target;
      }
      if (to.position || to.position === 0) {
        const position = to.position;
        delete to.position;
        tl.to(target, to, position);
        console.log(position);
      } else {
        tl.to(target, to);
      }
    });
  });
}

// -----------------------------------------------
// ハンバーガーを開閉する
// -----------------------------------------------
function toggleHamburger(target, hamburgerTweenTimeline) {
  const isOpen = target.classList.toggle('is-open');

  // 他のハンバーガーメニューを閉じる
  closeOtherHamburgers(target);

  // 通常のheaderハンバーガーの処理
  const header = target.closest('.js-header');
  if (header) {
    const drawer = header.querySelector('.js-drawer');
    header.classList.toggle('is-open');
    drawer.classList.toggle('is-open');

    if (isOpen) {
      // disableScroll();
      hamburgerTweenTimeline.play(0);
    } else {
      // enableScroll();
      hamburgerTweenTimeline.reverse();
    }
  }

  // FVハンバーガーの処理
  const fvHeader = target.closest('.top-fv');
  if (fvHeader) {
    const fvDrawer = fvHeader.querySelector('.fv-header__drawer .drawer');
    if (fvDrawer) {
      fvDrawer.classList.toggle('is-open');
      
      if (isOpen) {
        // disableScroll();
        hamburgerTweenTimeline.play(0);
      } else {
        // enableScroll();
        hamburgerTweenTimeline.reverse();
      }
    }
  }
}

// -----------------------------------------------
// 他のハンバーガーメニューを閉じる
// -----------------------------------------------
function closeOtherHamburgers(currentTarget) {
  // 現在のハンバーガー以外のすべてのハンバーガーを取得
  const allHamburgers = document.querySelectorAll('.js-hamburger');
  
  allHamburgers.forEach(hamburger => {
    if (hamburger !== currentTarget && hamburger.classList.contains('is-open')) {
      // 他のハンバーガーが開いている場合は閉じる
      const hamburgerElement = hamburger.querySelector('.hamburger') || hamburger;
      hamburgerElement.classList.remove('is-open');
      
      // 対応するドロワーも閉じる
      const header = hamburger.closest('.js-header');
      if (header) {
        const drawer = header.querySelector('.js-drawer');
        header.classList.remove('is-open');
        drawer.classList.remove('is-open');
      }
      
      const fvHeader = hamburger.closest('.top-fv');
      if (fvHeader) {
        const fvDrawer = fvHeader.querySelector('.fv-header__drawer .drawer');
        if (fvDrawer) {
          fvDrawer.classList.remove('is-open');
        }
      }
      
      // スクロールを有効にする
      enableScroll();
    }
  });
}

// -----------------------------------------------
// ハンバーガーを強制的に閉じる
// -----------------------------------------------
export function forceCloseHamburger() {
  // 開いているすべてのハンバーガーメニューを閉じる
  const openHamburgers = document.querySelectorAll('.js-hamburger.is-open');
  
  openHamburgers.forEach(hamburger => {
    const hamburgerElement = hamburger.querySelector('.hamburger') || hamburger;
    hamburgerElement.classList.remove('is-open');
    
    // 対応するドロワーも閉じる
    const header = hamburger.closest('.js-header');
    if (header) {
      const drawer = header.querySelector('.js-drawer');
      header.classList.remove('is-open');
      if (drawer) {
        drawer.classList.remove('is-open');
      }
    }
    
    const fvHeader = hamburger.closest('.top-fv');
    if (fvHeader) {
      const fvDrawer = fvHeader.querySelector('.fv-header__drawer .drawer');
      if (fvDrawer) {
        fvDrawer.classList.remove('is-open');
      }
    }
  });
  
  // スクロールを有効にする
  enableScroll();
}

// -----------------------------------------------
// ハンバーガーアニメーションタイムライン生成
// -----------------------------------------------
function createHamburgerTweenTimeline(target) {
  const line1 = target.querySelector('.hamburger__line span:nth-child(1)');
  const line2 = target.querySelector('.hamburger__line span:nth-child(2)');
  const line3 = target.querySelector('.hamburger__line span:nth-child(3)');
  const tl = gsap.timeline({ paused: true });
  const lineMarginPc = 8;
  const lineMarginSp = 6;

  // 中央線の位置を取得（2本目の線の位置）
  const centerY = Utils.isPc() ? lineMarginPc : lineMarginSp;
  
  // 1本目と3本目を中央（2本目の位置）に移動してから×マークに変化
  tl.to(line1, { y: centerY, duration: 0.2, ease: 'power1.inOut' }, 0); // 1本目を中央に移動
  tl.to(line3, { y: -centerY, duration: 0.2, ease: 'power1.inOut' }, 0); // 3本目を中央に移動
  tl.to(line2, { opacity: 0, duration: 0.15, ease: 'linear' }, 0.2); // 中央線を非表示
  tl.to(line1, { rotate: '-24deg', duration: 0.2, ease: 'power1.inOut' }, 0.3); // 上線を回転
  tl.to(line3, { rotate: '24deg', duration: 0.2, ease: 'power1.inOut' }, 0.3); // 下線を回転
  
  return tl;
}

// -----------------------------------------------
// スクロール無効
// -----------------------------------------------
function disableScroll() {
  document.querySelector('body').classList.add('disable-scroll');
  document.addEventListener('touchmove', preventDefaultEvent, { passive: false });
}

// -----------------------------------------------
// スクロール有効
// -----------------------------------------------
function enableScroll() {
  document.querySelector('body').classList.remove('disable-scroll');
  document.removeEventListener('touchmove', preventDefaultEvent, { passive: false });
}

// -----------------------------------------------
// スクロール無効用のイベント防止
// -----------------------------------------------
function preventDefaultEvent(event) {
  event.preventDefault();
}



//-------------------------------------------
// DOMロードイベント
//-------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  Utils.switchViewport(376, 390);

  //-------------------------------------------
  // イベント
  //-------------------------------------------
  // ハンバーガークリック
  if (document.querySelector('.js-hamburger')) {
    document.querySelectorAll('.js-hamburger').forEach((el) => {
      // 正しいハンバーガー要素を取得してタイムライン作成
      const hamburgerElement = el.querySelector('.hamburger');
      const localTimeline = createHamburgerTweenTimeline(hamburgerElement || el);
      
      el.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        
        // 現在のタイムラインを保存
        hamburgerTweenTimeline = localTimeline;
        
        // クリックされた要素から正しいハンバーガー要素を取得
        const clickedHamburgerElement = event.currentTarget.querySelector('.hamburger') || event.currentTarget.closest('.hamburger');
        toggleHamburger(clickedHamburgerElement || event.currentTarget, localTimeline);
      });
    });
  }


  // サービスセクションのScrollTrigger
  if (Utils.isPc()) {
    initServiceScrollTrigger();
  }
});

//-------------------------------------------
// Windowロードイベント
//-------------------------------------------
window.addEventListener('load', () => {
  setTimeout(function () {
    // スクロールアニメーション
    if (document.querySelector('.js-scroll-anime')) {
      initScrollAnimation('.js-scroll-anime');
    }

    // ループギャラリー
    if (document.querySelector('.js-loop-contents')) {
      document.querySelectorAll('.js-loop-contents').forEach(function (element) {
        // PC用とモバイル用のdurationを取得
        const baseDuration = parseInt(element.dataset.duration) || 100; // デフォルト100
        const mobileDuration = parseInt(element.dataset.durationMobile); // モバイル用（設定がなければundefined）

        // 最終的なdurationを決定（モバイルの場合はdata-duration-mobileを優先）
        const duration = Utils.isMobile() && mobileDuration ? mobileDuration : baseDuration;

        // 他のデータ属性も取得
        const minItems = parseInt(element.dataset.minItems) || 9; // デフォルト9
        const isReverse = element.dataset.reverse !== undefined; // data-reverse属性が指定されている場合はtrue

        // ul要素を取得
        const originalUl = element.querySelector('ul');
        let totalLiCount = originalUl.querySelectorAll('li').length;

        // ul要素とその子要素を必ず一つ複製
        const clonedUl = originalUl.cloneNode(true);
        originalUl.parentNode.appendChild(clonedUl);

        // さらに、liの数が合計minItems以上かつ偶数になるまで複製を追加
        totalLiCount += clonedUl.querySelectorAll('li').length;
        while (totalLiCount % 2 !== 0 || totalLiCount < minItems) {
          const additionalClonedUl = originalUl.cloneNode(true);
          originalUl.parentNode.appendChild(additionalClonedUl);
          totalLiCount += additionalClonedUl.querySelectorAll('li').length;
        }

        // ul要素の数が偶数になるように調整
        let ulCount = element.querySelectorAll('ul').length;
        if (ulCount % 2 !== 0) {
          const additionalClonedUl = originalUl.cloneNode(true);
          originalUl.parentNode.appendChild(additionalClonedUl);
          ulCount++;
        }

        // アニメーションの方向を設定
        const startX = isReverse ? '-50%' : '0%';
        const endX = isReverse ? '0%' : '-50%';

        // アニメーションの持続時間を計算
        const baseLiCount = 40; // 基準となるliの数
        const duration2 = (totalLiCount / baseLiCount) * duration;

        // gsapアニメーションの設定
        gsap.fromTo(
          element,
          { x: startX },
          {
            x: endX,
            duration: duration2, // アニメーションの持続時間を秒単位で設定
            ease: 'linear', // 一定速度で移動
            repeat: -1, // 無限に繰り返す
          }
        );
      });
    }

  }, 100); // 確実に最後に処理するよう遅延を入れる
});

// -----------------------------------------------
// サービスセクションのScrollTrigger
// -----------------------------------------------
function initServiceScrollTrigger() {
  if (!document.querySelector('.js-top-service')) return;
  
  const serviceItems = gsap.utils.toArray('.js-top-service-item');
  const serviceImages = gsap.utils.toArray('.js-top-service-image');
  
  if (serviceItems.length === 0 || serviceImages.length === 0) return;
  
  // 各サービス項目にScrollTriggerを設定
  serviceItems.forEach((item, index) => {
    ScrollTrigger.create({
      trigger: item,
      start: "top 60%",
      end: "bottom 40%",
      onEnter: () => switchServiceImage(index),
      onEnterBack: () => switchServiceImage(index),
      markers: false // デバッグ用（本番では削除）
    });
  });
  
  // 画像切り替え関数
  function switchServiceImage(targetIndex) {
    serviceImages.forEach((img, index) => {
      if (index === targetIndex) {
        gsap.to(img, { 
          opacity: 1, 
          duration: 0.6,
          ease: "power2.out"
        });
        img.classList.add('is-active');
      } else {
        gsap.to(img, { 
          opacity: 0, 
          duration: 0.6,
          ease: "power2.out"
        });
        img.classList.remove('is-active');
      }
    });
  }
  
  // 初期状態で最初の画像を表示
  if (serviceImages.length > 0) {
    gsap.set(serviceImages, { opacity: 0 });
    gsap.set(serviceImages[0], { opacity: 1 });
    serviceImages[0].classList.add('is-active');
  }
}
